import { FormList, HeaderTitle, Operation, Thumbnails } from '@/components';
import { deleteTrain, getTrainList, updateTrain } from '@/api';
import { st_train } from '@/utils/statetype';
import { toDateTime } from '@/utils/utils';
import { Button, message, Table, Switch } from 'antd';
import React, { useState } from 'react';
import { useTable } from '@/hooks';
import moment from 'moment';
import TrainEdit from './components/TrainEdit';

const { statusObj } = st_train;
function Train() {
  const [query, setQuery] = useState({});
  const [datas, setDatas] = useState({});
  const [visible, setVisible] = useState(false);

  const columns = {
    id: '展示编号',
    trainCategoryId: '分类编号',
    NOINDEX_categoryName: {
      title: '分类名称',
      render: (e) => (
        <span>{e?.TrainCategory?.name}</span>
      ),
    },
    title: {
      title: '标题',
    },
    content: {
      title: '内容',
      width: 200,
      ellipsis: true,
    },
    image: {
      title: '图片',
      render: e => <Thumbnails images={[e]} center />,
    },
    video: {
      title: '视频',
      render: e => <video src={e} width={100} onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)} />,
    },
    NOINDEX_status: {
      title: '是否启用',
      render: (e) => (
        <Switch
          checked={e.status === 1}
          checkedChildren='启用'
          unCheckedChildren='隐藏'
          onChange={(check) => updateTrainOperate({ id: e.id, status: check ? 1 : 0 })}
        />
      ),
    },
    NOINDEX_operation: {
      title: '操作',
      fixed: 'right',
      render: e => (
        <Operation
          listData={{
            update: () => {
              const { ...prop } = e;
              setVisible(true);
              setDatas({
                ...prop,
              });

            },
            delete: () => {
              deleteTrain({
                body: {
                  id: e.id,
                },
              }).then(() => {
                message.success('删除成功');
                flagFn(true);
              });
            },
          }}
        />
      ),
    },
  };

  const { tableProps, flagFn } = useTable({
    columns,
    API: getTrainList,
    isInit: false,
    params: {
      query,
    },
  });

  const formData = [
    {
      id: 'status',
      label: '是否启用',
      type: 'select',
      selects: statusObj,
    },
    {
      id: 'trainCategoryId',
      label: '分类id',
    },
  ];

  const changeQuery = (value = {}) => {
    setQuery(value);
    flagFn(true);
  };

  const updateTrainOperate = (body) => {
    updateTrain({ body: body }).then(() => {
      message.success('操作成功');
      flagFn();
    })
    // flagFn(true);
  };

  return (
    <>
      <HeaderTitle />
      <FormList
        formData={formData}
        changeQuery={changeQuery}
        extraRender={
          <Button type="primary" disabled={!global.isOperable} onClick={() => setVisible(true)}>
            添加
          </Button>
        }
      />
      <Table {...tableProps} />
      <TrainEdit
        data={datas}
        visible={visible}
        onChange={res => {
          if (res) flagFn();
          setVisible(false);
          setDatas({});
        }}
      />
    </>
  );
}

export default Train;
